export default "__VITE_ASSET__KmnUTbFg__"